var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdits = function SvgEdits(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      width: 13,
      height: 14
    },
    viewBox: "0 0 13 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.223 2.533H1.89A1.333 1.333 0 0 0 .557 3.867V11.2a1.333 1.333 0 0 0 1.333 1.333h7.333a1.333 1.333 0 0 0 1.334-1.333V7.867M9.614 1.59a1.333 1.333 0 1 1 1.885 1.885L5.775 9.2H3.89V7.315z"
  })));
};
export default SvgEdits;